// extracted by mini-css-extract-plugin
export default {"kpis":"kpis_kpis__UZoTR","kpi-line":"kpis_kpi-line__9+kCS","kpi-col":"kpis_kpi-col__KgkN6","subtitle":"kpis_subtitle__w16J5","kpi-line-header":"kpis_kpi-line-header__RvyHH"};